import { render, staticRenderFns } from "./DataConfirm.vue?vue&type=template&id=aef23dfa&"
import script from "./DataConfirm.vue?vue&type=script&lang=js&"
export * from "./DataConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports